import styled from 'styled-components/macro'

import { Layout, Text } from '@loadsmart/miranda-react'

import { screen } from 'legacy/styles/screen'

import { Logo } from '../logo/Logo'

const ShipperWrapper = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
`

const LogoWrapper = styled.div`
  display: none;

  ${screen.md} {
    display: block;
  }
`

export type ShipperInformationProps = {
  companyName?: string
  contactName?: string
  email?: string
  phone?: string
  logo?: string
  showContactInfo?: boolean
}

export function ShipperInformation({
  companyName,
  contactName,
  email,
  logo,
  phone,
  showContactInfo,
  ...props
}: ShipperInformationProps) {
  return (
    <Layout.Group align="center" gap="spacing-5" {...props}>
      {logo && (
        <LogoWrapper>
          <Logo url={logo} />
        </LogoWrapper>
      )}
      {companyName && (
        <ShipperWrapper>
          <Text variant="body-sm">Shipper</Text>
          <Text variant="body-md-bold">{companyName}</Text>
        </ShipperWrapper>
      )}
      {showContactInfo && (
        <Layout.Stack gap="spacing-0-5" align="flex-start">
          <Text variant="body-sm">Shipper contact:</Text>
          <Layout.Group gap="spacing-1">
            {contactName && <Text variant="body-md">{contactName}</Text>}
            {email && contactName && <Text>/</Text>}
            {email && <Text variant="body-md">{email}</Text>}
            {phone && <Text>/</Text>}
            {phone && <Text variant="body-md">{phone}</Text>}
          </Layout.Group>
        </Layout.Stack>
      )}
    </Layout.Group>
  )
}
